import { runtime } from '../Runtime';
export class SolidPackages {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get packages() {
        return this.parent;
    }
    get Edit() {
        return this.packages.Edit.availablePackage;
    }
    get EditLazy() {
        return this.packages.EditLazy.availablePackage;
    }
    get Abfrager() {
        return this.packages.Abfrager.availablePackage;
    }
    get Defer() {
        return this.packages.Defer.availablePackage;
    }
    get Lazy() {
        return this.packages.Lazy.availablePackage;
    }
    get Grundschule() {
        return this.packages.Grundschule.availablePackage;
    }
    get Rare() {
        return this.packages.Rare.availablePackage;
    }
    get Mobile() {
        return this.packages.Mobile.availablePackage;
    }
    get Server() {
        return runtime.solidServerRuntime.serverPackages.PackageServer;
    }
    get Exotic() {
        return this.packages.Exotic.availablePackage;
    }
    get Large() {
        return this.packages.Large.availablePackage;
    }
    get Multi() {
        return this.packages.Multi.availablePackage;
    }
}
